<template>
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.0759 5.71954C19.5924 5.20482 20.4297 5.20482 20.9462 5.71954C21.4626 6.23426 21.4626 7.06879 20.9462 7.58352L11.5949 16.9034C11.0784 17.4181 10.241 17.4181 9.72459 16.9034C9.20813 16.3887 9.20813 15.5541 9.72459 15.0394L19.0759 5.71954Z"
      fill="white"
    />
    <path
      d="M20.9424 24.4168C21.4589 24.9315 21.4589 25.7661 20.9424 26.2808C20.4259 26.7955 19.5886 26.7955 19.0721 26.2808L9.72084 16.9609C9.20438 16.4462 9.20438 15.6116 9.72084 15.0969C10.2373 14.5822 11.0746 14.5822 11.5911 15.0969L20.9424 24.4168Z"
      fill="white"
    />
  </svg>
</template>

<script>
export default {
  name: "FilterArrowIcon",
};
</script>

<style scoped></style>
